
import { mixins, Options } from 'vue-class-component';
import CampaignWidgetMixin from '@/mixins/campaignWidget';

@Options({
  props: {
    checkerTokenAddress: {
      type: String,
      required: false
    }
  }
})
export default class MTokenChecker extends mixins(CampaignWidgetMixin) {
  checkerTokenAddress: string | undefined;

  tokenHasBeenUsed: number | null = null;

  async checkToken(submitEvent: any) {
    this.tokenHasBeenUsed = null;
    const elements = submitEvent.target.elements;
    // TODO: In the future, the form should pass in network as a campaign
    // can have multiple networks. We would want the token checker to be
    // configurable for multiple networks
    const network = elements.network ?? this.network ?? 1;
    // Match token address and tokenId to regexs
    if (
      !(
        elements.tokenAddress?.value.match(/^0x[0-9a-fA-F]{40}$/) ||
        this.checkerTokenAddress?.match(/^0x[0-9a-fA-F]{40}$/)
      ) ||
      !elements.tokenId.value.match(/^\d+$/)
    ) {
      this.tokenHasBeenUsed = -1;
      return;
    }
    const res = await this.state.RedeemAPIClient.checkTokenHasBeenUsed(
      parseInt(this.mmid!),
      network,
      elements.tokenAddress?.value ? elements.tokenAddress?.value : this.checkerTokenAddress,
      elements.tokenId.value
    );
    this.tokenHasBeenUsed = res ? 1 : 0;
  }
}
